
import { useRef } from 'react';
import { toast } from 'sonner';
import { DashboardWidgetRefs, RetryHandlers } from '@/components/dashboard/types';

export function useWidgetRefs() {
  // Define widget refs
  const widgetRefs: DashboardWidgetRefs = {
    dashboard: useRef<HTMLDivElement>(null),
    history: useRef<HTMLDivElement>(null),
    sitemap: useRef<HTMLDivElement>(null),
    'deep-analysis': useRef<HTMLDivElement>(null),
    recommended: useRef<HTMLDivElement>(null),
    'faq-serp': useRef<HTMLDivElement>(null),
  };

  // Error retry handlers for each feature
  const retryHandlers: RetryHandlers = {
    sitemap: () => {
      toast.info("Retrying sitemap visualization...");
    },
    deepAnalysis: () => {
      toast.info("Retrying page analysis...");
    },
    recommended: () => {
      toast.info("Refreshing recommended articles...");
    },
    faqSerp: () => {
      toast.info("Refreshing FAQ analysis...");
    }
  };

  return {
    widgetRefs,
    retryHandlers
  };
}
